//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Button, IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails } from '@mui/material';

import { ArrowRight, Close, Search, Visibility , ArrowForward, ContentCopy } from '@mui/icons-material';
import { Col, Row } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
//  -- Constants ----------------------
import { Typography } from '@mui/material';
import PasswordRevealInline from 'components/PasswordRevealInline';
import COLOR from 'utils/constants/color';
//  -- Components ---------------------
import Loading from 'components/Loading';
import LoadingWrapper from 'components/LoadingWrapper';
//  -- Thunks -------------------------
import { get, isEmpty, map } from 'lodash';
import { lighten } from 'polished';
import { handleUserByGoogleName , handleUserByGoogleId  } from 'store/googleClassRoom/thunks';
import { createKeystore } from "store/keystore/thunks";
import { v4 } from 'uuid';
import { useNavigate } from "react-router-dom";
import { getUserIntegration } from 'utils';
import SentryWrap from 'components/Sentry';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Wrapper = styled.div`
	height: 100%;
	width: 100%;
`;

const WrapperForm = styled.form`
	padding: 40px 0px;
	width: 100%;
`;
const Error = styled.div`
    background-color: ${lighten(0.4, 'red')};
    border: 1px solid red;
    border-radius: 3px;
    color: red;
    font-size: 14px;
    font-weight: 500;
    margin: 0px auto 16px;
    max-width: 480px;
    padding: 8px;
    text-align: center;
    width: 100%;
`;
const Label = styled.div`
   font-size:14px;
   color:${COLOR.white};
`;
const LabelTop = styled.div`
   font-size:18px;
   color:${COLOR.white};
`;
const ItemsTabsList = styled.div`
    display: inline-block;
    flex-direction: column;
    min-height: 100px;
    border-radius: 12px;
    min-width: 200px;
    background-color: ${COLOR.indigodeep};
    width: 90%;
    padding: 16px;
    margin-top: 10px;
    min-height: 220px;
`;
const ClassUsersWrapper = styled.div`
    border: 1px dashed ${COLOR.black700};
    border-radius: 3px;
    margin-bottom: 8px;
    width:102%;
    &:last-child {
        margin-bottom: 0px;
    }
`;
const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    width:90vw;
    height:90vh;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;
const ModalSection = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    width:90vw;
    height:100%;
    overflow:auto;
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
`;


const AccordianTitle = styled(Typography)`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    width:100%;
`

// Accordion (MUI v5)
const Accordion = styled(MuiAccordion)(({ theme }) => ({
    border: '1px solid white',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: 'auto',
    },
  }));
  
  // AccordionSummary (MUI v5)
  const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
    backgroundColor: '#03989e',
    color: 'white',
    textTransform: 'capitalize',
    borderBottom: '1px solid white',
    marginBottom: -1,
    minHeight: 30,
    '&.Mui-expanded': {
      minHeight: 30,
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '8px 0',
    },
  }));
  
  // AccordionDetails (MUI v5)
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: '2px',
  }));

const Rotate = styled.div`
    align-items: center;
    display: flex;
    height: 16px;
    justify-content: center;
    margin-right: 4px;
    transform: ${p => p.open ? 'rotate(90deg)' : 'rotate(0deg)'};
    transition: all 300ms ease;
    width: 16px;
`;
const ContentArea = styled.div`
width: 90%;
margin-top: 28px;
`;
//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
const UserInfoAres = ({ data }) => {
    const { school, district } = data;
    const [loader,setLoader] = useState(false);
    const [copied, setCopied] = useState(false);
    const openLoginInNewWindow = async () => {
        setLoader(true);
        const key = v4()
        await createKeystore(get(data, "user.id", ''), key)
        const url = `${window.location.origin}?key=${key}`
        window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
        setLoader(false);
      }
    
    const copyUserInfo = async () => {
        const userInfo = [
            'User on OWE Platform',
            '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
            `Id: ${get(data, "user.id", '')}`,
            `Create at: ${get(data, "user.createdAt", null) ? moment(parseInt(get(data, "user.createdAt", ''))).format("MM/DD/YYYY") : 'N/A'}`,
            `First Name: ${get(data, "user.firstName", '')}`,
            `Last name: ${get(data, "user.lastName", '')}`,
            `Role: ${get(data, "user.role", '')}`,
            `User Name: ${get(data, "user.username", '')}`,
            `Password: (use Show password in UI — not copied)`,
            `School: ${get(data, "user.school", '')}`,
            `District: ${get(data, "user.district", '')}`,
            `Classes: ${get(data, "classes.length", 0)}`,
            `Integration: ${getUserIntegration(data?.user)}`
        ].join('\n');
        
        try {
            await navigator.clipboard.writeText(userInfo);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };
    
    return (<Row style={{ width: "100%" }}>
        <Col span={12} style={{ paddingRight: "8px" }}>
            {!isEmpty(data.user) && <div style={{
                background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                borderRadius: '8px',
                padding: '12px',
                color: 'white',
                boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                border: '1px solid rgba(255,255,255,0.1)',
                height: 'fit-content',
            }}>
                <div style={{
                    fontSize: '14px',
                    fontWeight: '700',
                    marginBottom: '12px',
                    textAlign: 'center',
                    color: '#ecf0f1',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                }}>
                    <span>User on OWE Platform</span>
                    <Tooltip title={copied ? "Copied!" : "Copy user information"} arrow placement="top">
                        <IconButton
                            onClick={copyUserInfo}
                            size="small"
                            style={{
                                color: '#ecf0f1',
                                padding: '4px'
                            }}
                        >
                            <ContentCopy style={{ fontSize: '16px' }} />
                        </IconButton>
                    </Tooltip>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingLeft:56, paddingRight:56 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Id:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', fontFamily: 'monospace', textAlign: 'right', wordBreak: 'break-all' }}>{get(data, "user.id", '')}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Create at:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(data, "user.createdAt", null) ? moment(parseInt(get(data, "user.createdAt", ''))).format("MM/DD/YYYY") : null}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>First Name:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(data, "user.firstName", '')}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Last name:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(data, "user.lastName", '')}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Role:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(data, "user.role", '')}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>User Name:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right', wordBreak: 'break-all' }}>{get(data, "user.username", '')}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Password:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right', wordBreak: 'break-all' }}><PasswordRevealInline userId={get(data, "user.id")} username={get(data, "user.username")} /></span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>School:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(data, "user.school")}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>District:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(data, "user.district")}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Classes:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(data, "classes.length", 0)}</span>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Integration:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{getUserIntegration(data?.user)}</span>
                    </div>
                </div>
                
                <div style={{ marginTop: '12px', textAlign: 'center' }}>
                    <Button 
                        color="primary" 
                        variant="contained" 
                        onClick={openLoginInNewWindow}
                        style={{
                            background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                            color: 'white',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            fontWeight: '600',
                            textTransform: 'none',
                            fontSize: '11px',
                            boxShadow: '0 2px 8px rgba(23, 162, 184, 0.3)',
                            border: 'none',
                            minWidth: '120px',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #138496 0%, #117a8b 100%)',
                                boxShadow: '0 4px 12px rgba(23, 162, 184, 0.4)'
                            }
                        }}
                    >
                        {loader && <Loading size={12} white />}
                        Login to account
                        <ArrowForward
                            style={{
                                fontSize: "8px",
                                marginLeft: "4px",
                            }}
                        />
                    </Button>
                </div>
            </div>}
        </Col>
        <Col span={12} style={{ paddingLeft: "8px" }}>
            {!isEmpty(school) && <div style={{
                background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                borderRadius: '8px',
                padding: '12px',
                color: 'white',
                boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                border: '1px solid rgba(255,255,255,0.1)',
                height: '100%'
            }}>
                <div style={{
                    fontSize: '14px',
                    fontWeight: '700',
                    marginBottom: '12px',
                    textAlign: 'center',
                    color: '#ecf0f1',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>
                    School & District
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingLeft: 56, paddingRight: 56 }}>
                    <div style={{
                        fontSize: '12px',
                        fontWeight: '600',
                        marginTop: '8px',
                        marginBottom: '4px',
                        color: '#bdc3c7',
                        textTransform: 'uppercase'
                    }}>
                        School
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Display Name:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(school, "displayName", '')}</span>
                    </div>
                    
                    <div style={{
                        fontSize: '12px',
                        fontWeight: '600',
                        marginTop: '12px',
                        marginBottom: '4px',
                        color: '#bdc3c7',
                        textTransform: 'uppercase'
                    }}>
                        District
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>Display Name:</span>
                        <span style={{ color: '#ecf0f1', fontSize: '11px', textAlign: 'right' }}>{get(district, "displayName", '')}</span>
                    </div>
                </div>
            </div>}
        </Col>
    </Row>)
}
const ClassInfoArea = ({ handleChange, data, classEpendOwe , googleInfo}) => {
    const { classes } = data;
    return (<Row style={{width:"100%", marginTop: "32px"}}>
        <Col span={12} style={{paddingRight: "16px"}}>
            <div style={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                border: '1px solid #dee2e6'
            }}>
                <LabelTop style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#495057',
                    textAlign: 'center',
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>
                    Active Classes
                </LabelTop>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {map(classes, cls => {
                        return (
                            <div key={cls.googleId} style={{
                                background: '#fff',
                                borderRadius: '8px',
                                border: '1px solid #e9ecef',
                                overflow: 'hidden',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}>
                                <Accordion square expanded={classEpendOwe == cls.googleId} onChange={handleChange(cls.googleId)}>
                                    <AccordionSummary 
                                        aria-controls="panel1d-content" 
                                        id="panel1d-header"
                                        style={{
                                            background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                            color: 'white',
                                            minHeight: '40px',
                                            '&:hover': {
                                                background: 'linear-gradient(135deg, #0056b3 0%, #004085 100%)'
                                            }
                                        }}
                                    >
                                        <AccordianTitle style={{ color: 'white', fontWeight: '600', fontSize: '14px' }}>
                                            <span>{cls.displayName} {cls.archived ? <span style={{ color: '#ff6b6b' }}>(Archived)</span> : ''}</span>
                                            <div style={{ display:"flex", alignItems: 'center', gap: '6px' }}>
                                                <span style={{ 
                                                    background: 'rgba(255, 255, 255, 0.2)', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '8px',
                                                    fontSize: '10px',
                                                    fontWeight: '600'
                                                }}>
                                                    Students({get(cls,"classUsers.length",0)})
                                                </span>
                                                <Rotate open={classEpendOwe == cls.googleId}>
                                                    <ArrowRight style={{ color: 'white' }} />
                                                </Rotate>
                                            </div>
                                        </AccordianTitle>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ padding: '0' }}>
                                        <div style={{ padding: '12px' }}>
                                            <TableContainer>
                                                <Table style={{ width: "100%", textAlign: "center" }}>
                                                    <TableHead>
                                                        <TableRow style={{ background: '#f8f9fa' }}>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Id</TableCell>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Username</TableCell>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>First name</TableCell>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Last Name</TableCell>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Google Id</TableCell>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Password</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {map(cls.classUsers, cuser => {
                                                            return (
                                                                <TableRow style={{ '&:hover': { background: '#f8f9fa' } }}>
                                                                    <TableCell style={{ textAlign: "center" }}>
                                                                        <Tooltip title={get(cuser, "id", '')} arrow placement="top">
                                                                            <span style={{ cursor: 'help' }}>
                                                                                {get(cuser, "id", '').length > 5 ? `${get(cuser, "id", '').substring(0, 5)}...` : get(cuser, "id", '')}
                                                                            </span>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: "center" }}>{get(cuser, "username", '')}</TableCell>
                                                                    <TableCell style={{ textAlign: "center" }}>{get(cuser, "firstName", '')}</TableCell>
                                                                    <TableCell style={{ textAlign: "center" }}>{get(cuser, "lastName", '')}</TableCell>
                                                                    <TableCell style={{ textAlign: "center" }}>{get(cuser, "googleId", '')}</TableCell>
                                                                    <TableCell style={{ textAlign: "center" }}><PasswordRevealInline userId={get(cuser, "id")} username={get(cuser, "username")} /></TableCell>
                                                                </TableRow>)
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        )
                    })}
                </div>
            </div>
        </Col>
        <Col span={12} style={{paddingLeft: "16px"}}>
            <div style={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                border: '1px solid #dee2e6'
            }}>
                <LabelTop style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#495057',
                    textAlign: 'center',
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>
                    Integration Classes
                </LabelTop>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {map(googleInfo.classes, cls => {
                        return (
                            <div key={cls.id+"u"} style={{
                                background: '#fff',
                                borderRadius: '8px',
                                border: '1px solid #e9ecef',
                                overflow: 'hidden',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}>
                                <Accordion square expanded={classEpendOwe == cls.id} onChange={handleChange(cls.id)}>
                                    <AccordionSummary 
                                        aria-controls="panel1d-content" 
                                        id="panel1d-header"
                                        style={{
                                            background: 'linear-gradient(135deg, #6f42c1 0%, #5a2d91 100%)',
                                            color: 'white',
                                            minHeight: '40px',
                                            '&:hover': {
                                                background: 'linear-gradient(135deg, #5a2d91 0%, #4c1d7a 100%)'
                                            }
                                        }}
                                    >
                                        <AccordianTitle style={{ color: 'white', fontWeight: '600', fontSize: '14px' }}>
                                            <span>Class: {cls.name}</span>
                                            <Rotate open={classEpendOwe == cls.id}>
                                                <ArrowRight style={{ color: 'white' }} />
                                            </Rotate>
                                        </AccordianTitle>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ padding: '0' }}>
                                        <div style={{ padding: '12px' }}>
                                            <TableContainer>
                                                <Table style={{ width: "100%", textAlign: "center" }}>
                                                    <TableHead>
                                                        <TableRow style={{ background: '#f8f9fa' }}>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Id</TableCell>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Name</TableCell>
                                                            <TableCell style={{ textAlign: "center", fontWeight: '600', color: '#495057' }}>Email</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {map(cls.student, cuser => {
                                                            return (
                                                                <TableRow style={{ '&:hover': { background: '#f8f9fa' } }}>
                                                                    <TableCell style={{ textAlign: "center" }}>
                                                                        <Tooltip title={get(cuser, "userId", '')} arrow placement="top">
                                                                            <span style={{ cursor: 'help' }}>
                                                                                {get(cuser, "userId", '').length > 5 ? `${get(cuser, "userId", '').substring(0, 5)}...` : get(cuser, "userId", '')}
                                                                            </span>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: "center" }}>{get(cuser, "profile.name.fullName", '')}</TableCell>
                                                                    <TableCell style={{ textAlign: "center" }}>{get(cuser, "profile.emailAddress", '')}</TableCell>
                                                                </TableRow>
                                                            )
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        )
                    })}
                </div>
            </div>
        </Col>
    </Row>)
}

const GoogleUserViewContainer = ({
}) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ users: null, classes: [] });
    const [classEpendOwe, setClassExpendOwe] = useState(-1)
    const [username, setCleverUsername] = useState('')
    const [userList, setUserList] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [userInfoLoader, setUserInfoLoader] = useState(-1)
    const [selectedUserInfo, setSelectedUserInfo] = useState({
        users: null, classes: []
    })
    const handleChange = (panel) => (event, newExpanded) => {
        setClassExpendOwe(newExpanded ? panel : -1);
    };
    const navigate = useNavigate()
    const fetchCleverUserByName = async () => {
        if (username) {
            setLoading(true)
            const users = await handleUserByGoogleName(username.trim())
            setUserList(users)
            setLoading(false)
        }

    }
    const fetchApis = async (id) => {
        if (userInfoLoader !== -1) return;
        setUserInfoLoader(id)       
        setSelectedUserInfo({ users: null, classes: []})
        const userData = await handleUserByGoogleId(id)
        if(userData&&userData.user){
            setSelectedUserInfo(userData)
        }
        setTimeout(()=>{
            setUserInfoLoader(-1)
            setOpenModal(true)
        },2000)
       
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        fetchCleverUserByName()

    };

    return (
        <SentryWrap>
            <Modal
                open={openModal}
                onClose={e => setOpenModal(false)}
                style={{ height: "100%", width: "100%" }}
            >
                <ModalContent>
                    <Row style={{ justifyContent: "flex-end", width: "100%" }}>
                        <IconButton
                            onClick={e => setOpenModal(false)}
                            style={{ padding: 0, marginRight: 10 }}
                        >
                            <Close color="secondary" />
                        </IconButton>
                    </Row>
                    <ModalSection>
                        <UserInfoAres data={data} />
                        <ClassInfoArea data={data} classEpendOwe={classEpendOwe} handleChange={handleChange} googleInfo={selectedUserInfo} />
                    </ModalSection>

                </ModalContent>
            </Modal>
            <div style={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderRadius: '16px',
                padding: '24px',
                marginBottom: '24px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                border: '1px solid #dee2e6'
            }}>
                <div style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    color: '#495057',
                    marginBottom: '20px',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                }}>
                    Google User Search
                </div>
                
                <WrapperForm onSubmit={handleSubmit}>
                    <Row className="fixAdminInput" gutter={[16, 16]} style={{ alignItems: 'center' }}>
                        <Col span={8}>
                            <TextField
                                id="name"
                                name="name"
                                label="First name or last name"
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                variant="outlined"
                                onChange={e => {
                                    setCleverUsername(e.target.value)
                                }}
                                value={username}
                                style={{ width: '100%' }}
                                InputProps={{
                                    style: {
                                        height: '40px',
                                        fontSize: '14px',
                                        borderRadius: '8px'
                                    }
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '&:hover fieldset': {
                                            borderColor: '#007bff',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#007bff',
                                        },
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: '#007bff',
                                    }
                                }}
                            />
                        </Col>

                        <Col>
                            <Button 
                                disabled={loading} 
                                variant="contained" 
                                color="primary" 
                                type="submit"
                                style={{
                                    height: '40px',
                                    padding: '0 20px',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    textTransform: 'none',
                                    background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                    boxShadow: '0 4px 12px rgba(0, 123, 255, 0.3)',
                                    border: 'none',
                                    minWidth: '100px',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #0056b3 0%, #004085 100%)',
                                        boxShadow: '0 6px 16px rgba(0, 123, 255, 0.4)'
                                    }
                                }}
                            >
                                {loading ? <Loading size={16} white /> : 'Search'}
                                <Search style={{ height: '16px', margin: '0px 0px 0px 6px', width: '16px' }} />
                            </Button>
                        </Col>
                    </Row>
                </WrapperForm>
            </div>
            <Wrapper>
                <LoadingWrapper loading={false}>
                    {userList.length > 0 ? <Table style={{ width: "100%", textAlign: "center" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ textAlign: "center" }}>Username</TableCell>
                                <TableCell style={{ textAlign: "center" }}>First name</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Last Name</TableCell>
                                <TableCell style={{ textAlign: "center" }}>role</TableCell>
                                <TableCell style={{ textAlign: "center" }}>google id</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Password</TableCell>
                                <TableCell style={{ textAlign: "center" }}>view</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {map(userList, u => {
                                const cuser = u.user;
                                return (<>
                                    <TableRow key={cuser.id}>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "username", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "firstName", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "lastName", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "role", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "googleId", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}><PasswordRevealInline userId={get(cuser, "id")} username={get(cuser, "username")} /></TableCell>
                                        <TableCell style={{ textAlign: "center" }}><IconButton onClick={() => {
                                            fetchApis(cuser.googleId)
                                            setData(u)
                                        }}> {userInfoLoader ===cuser?.googleId?<Loading size={14}/>:<Visibility style={{ color: COLOR.green }} />}</IconButton></TableCell>
                                    </TableRow>
                                </>)
                            })}
                        </TableBody>
                    </Table> : null}
                </LoadingWrapper>
            </Wrapper>
        </SentryWrap>
    );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    logs: state.logs,
    currentUser: state.currentUser
});

export default connect(mapStateToProps, null)(GoogleUserViewContainer);
